import { createUseStyles } from 'react-jss';
import colors from "../../../utils/colors";







var styles = {
  header: function header(_ref) {var isMultiProductPortfolio = _ref.isMultiProductPortfolio;return {
      margin: isMultiProductPortfolio ? '1.5rem 0 2rem' : '1.5rem 0',
      borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
      paddingBottom: '1.5rem'
    };},
  mobileHeader: function mobileHeader(_ref2) {var isMultiProductPortfolio = _ref2.isMultiProductPortfolio;return {
      margin: isMultiProductPortfolio ? '1.5rem 0 2rem' : '1.5rem 0',
      borderBottom: "0.1rem solid ".concat(colors.neutral[300]),
      paddingBottom: '1.5rem',

      flexDirection: 'column',
      gap: '1rem',
      '& button': {
        margin: 0
      },
      '& h2': {
        maxWidth: '100%',
        fontSize: '1.6rem'
      },
      '& h2 svg': {
        display: 'none'
      }
    };},
  shortHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '1.5rem',
    '& button': {
      marginLeft: 'auto',
      fontWeight: 400,
      paddingRight: 0,
      paddingLeft: 0
    },
    '& h2': {
      width: 'auto',
      maxWidth: '64%',
      marginRight: '2rem'
    }
  },
  innerProduct: function innerProduct(_ref3) {var isMultiProductPortfolio = _ref3.isMultiProductPortfolio;return {
      padding: isMultiProductPortfolio && '0 1rem 1.5rem',
      borderRadius: isMultiProductPortfolio && '0.6rem',
      border: isMultiProductPortfolio && "1px solid ".concat(colors.neutral[300]),
      '&:not(:last-child)': {
        marginBottom: isMultiProductPortfolio && '2rem'
      }
    };},
  portfolioMainData: function portfolioMainData(_ref4) {var showMobileLayoutVersion = _ref4.showMobileLayoutVersion;return {
      display: 'flex',
      flexDirection: showMobileLayoutVersion ? 'column' : 'row'
    };},
  actionButtonWrapper: function actionButtonWrapper(_ref5) {var isMultiProductPortfolio = _ref5.isMultiProductPortfolio;return {
      flex: '2 1 65%',
      '& button': {
        maxWidth: isMultiProductPortfolio && '40%'
      }
    };},
  actionButton: function actionButton(_ref6) {var showMobileLayoutVersion = _ref6.showMobileLayoutVersion;return {
      textTransform: 'uppercase',
      fontSize: '1.6rem',
      textAlign: 'left',
      alignSelf: 'flex-start',
      justifyContent: 'flex-start',
      paddingLeft: showMobileLayoutVersion ? 0 : '2rem'
    };},
  ratesList: function ratesList(_ref7) {var showMobileLayoutVersion = _ref7.showMobileLayoutVersion,isMultiProductPortfolio = _ref7.isMultiProductPortfolio;return {
      flex: '1 0 35%',
      paddingRight: '2rem',
      boxSizing: 'border-box',
      marginBottom: showMobileLayoutVersion ? isMultiProductPortfolio ? 0 : '2rem' : 0,
      borderRight: showMobileLayoutVersion ? 'none' : "0.1rem solid ".concat(colors.neutral[300]),
      padding: showMobileLayoutVersion && isMultiProductPortfolio ? 0 : '0 0 2rem',
      borderBottom:
      showMobileLayoutVersion && !isMultiProductPortfolio && "0.1rem solid ".concat(colors.neutral[300]),
      '& span:first-child': {
        fontSize: '1.4rem'
      },
      '& li': {
        maxWidth: showMobileLayoutVersion && '25rem'
      }
    };},
  cartItemContentWrapper: function cartItemContentWrapper(_ref8) {var showMobileLayoutVersion = _ref8.showMobileLayoutVersion;return {
      border: "1px solid ".concat(colors.neutral[400]),
      borderRadius: '1rem',
      backgroundColor: colors.neutral.white,
      padding: showMobileLayoutVersion ? '2rem' : '2.4rem 3.2rem',
      boxSizing: 'border-box',
      flex: '2 1 55%',
      overflowX: 'auto',
      position: 'relative'
    };},
  cartItemContentWrapperChecked: function cartItemContentWrapperChecked() {return {
      padding: '2rem 1.6rem',
      borderLeft: "16px solid ".concat(colors.blue[600]),
      borderRight: "4px solid ".concat(colors.blue[600]),
      borderBottom: "4px solid ".concat(colors.blue[600]),
      borderTop: "4px solid ".concat(colors.blue[600])
    };},
  portfolioHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  marketingTag: {
    margin: 0,
    fontSize: '1.2rem',
    padding: '0.4rem 1rem',
    borderRadius: '0.4rem',
    backgroundColor: colors.orange[300]
  },
  sponsorLogo: function sponsorLogo(_ref9) {var showMobileLayoutVersion = _ref9.showMobileLayoutVersion;return {
      zIndex: 5,
      position: 'relative',
      '& img': {
        height: showMobileLayoutVersion && '1.5rem'
      }
    };}
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map